module.exports = __webpack_public_path__ + "img/dsci0006.d92b5f63.jpg";